module.exports = {
          srcSet: __webpack_public_path__ + "public/f8c7ce78bff4f39ad2c9293acacc4179-40.png"+" 40w",
          images:[ {path: __webpack_public_path__ + "public/f8c7ce78bff4f39ad2c9293acacc4179-40.png",width: 40,height: 40}],
          src: __webpack_public_path__ + "public/f8c7ce78bff4f39ad2c9293acacc4179-40.png",
          toString:function(){return __webpack_public_path__ + "public/f8c7ce78bff4f39ad2c9293acacc4179-40.png"},
          
          width: 40,
          height: 40
        }